import _ from "underscore";
import React from "react";
import {styled} from "styled-components";

import GroupRow from "./group_row";

import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {WorkflowInstanceId} from "common/flowmaster/types/workflow";
import {Uuid} from "common/types/global";

const GroupedTableCellHeader = styled.th`
  text-align: left;
  font-size: 1.25em;
`;

type Props = {
  organisationId: OrganisationId;
  workflowTests: AggregatedWorkflowTest[];
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
  groupState: Record<WorkflowInstanceId, {isOpen: boolean}>;
  toggleOpen: (id: number | string) => void;
};

export default function GroupedTestsTable({
  organisationId,
  workflowTests,
  updateValue,
  groupState,
  toggleOpen,
}: Props) {
  const groups: Record<
    Uuid,
    Record<WorkflowInstanceId, AggregatedWorkflowTest[]>
  > = Object.fromEntries(
    Object.entries(
      _.groupBy(workflowTests, test => test.config_group_id ?? test.issue_id),
    ).map(([id, group]) => [id, _.groupBy(group, item => item.config_id)]),
  );
  const sortedGroupsEntries = _.sortBy(Object.entries(groups), ([, groups]) => {
    const first = Object.values(groups)[0]?.[0];
    return `${first?.workflow_name}::${
      first?.config_name ?? first?.issue_name
    }`;
  });
  return (
    <table style={{width: "100%", borderSpacing: "0px"}}>
      <thead>
        <tr style={{backgroundColor: "#ddd"}}>
          <GroupedTableCellHeader>Definition</GroupedTableCellHeader>
          <GroupedTableCellHeader>Config</GroupedTableCellHeader>
          <GroupedTableCellHeader>Version</GroupedTableCellHeader>
          <GroupedTableCellHeader>Docs</GroupedTableCellHeader>
          <GroupedTableCellHeader>Revisions</GroupedTableCellHeader>
          <GroupedTableCellHeader>Avg Runs</GroupedTableCellHeader>
          <GroupedTableCellHeader>100% Rate</GroupedTableCellHeader>
          <GroupedTableCellHeader>Avg Score</GroupedTableCellHeader>
        </tr>
      </thead>
      <tbody>
        {sortedGroupsEntries.map(([key, groupRevisions]) => {
          return (
            <GroupRow
              key={key}
              organisationId={organisationId}
              state={groupState[key]}
              groupRevisions={groupRevisions}
              toggleOpen={() => toggleOpen(key)}
              updateValue={updateValue}
            />
          );
        })}
      </tbody>
    </table>
  );
}
